import styled from '@/styles';

export const CardBox = styled('section', {
  backgroundColor: '#FFFFFF',
  border: '1px solid #DADADA',
  borderRadius: '8px',
  minWidth: 0,
});

export const CardHeader = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '12px',
  padding: '16px 20px',
  borderBottom: '1px solid #EDEDED',
});

export const CardTitle = styled('h2', {
  margin: 0,
  fontSize: '16px',
  fontWeight: 700,
});

export const Rows = styled('div', {
  display: 'grid',
  gridTemplateColumns: '160px minmax(0, 1fr)',
});

export const RowLabel = styled('div', {
  padding: '14px 20px',
  fontWeight: 600,
  borderTop: '1px solid #F0F0F0',
  '&:first-child': { borderTop: 'none' },
});

export const RowBody = styled('div', {
  padding: '14px 20px',
  borderTop: '1px solid #F0F0F0',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '8px 14px',
  minWidth: 0,
  '&:nth-child(2)': { borderTop: 'none' },
});

export const Caption = styled('span', {
  fontSize: '13px',
  color: '#5A5A5A',
});

export const LinkText = styled('a', {
  fontSize: '13px',
  fontWeight: 600,
  color: '#1E8E3E',
});

export const IconButton = styled('button', {
  marginLeft: 'auto',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  border: '1px solid #DADADA',
  borderRadius: '6px',
  background: '#FFFFFF',
  cursor: 'pointer',
  '&:disabled': { opacity: 0.6, cursor: 'default' },
});

export const Segmented = styled('div', {
  display: 'inline-flex',
  border: '1px solid #DADADA',
  borderRadius: '8px',
  overflow: 'hidden',
  alignSelf: 'flex-start',
  '& button': {
    padding: '8px 18px',
    border: 'none',
    background: '#FFFFFF',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    '&:disabled': { cursor: 'default', opacity: 0.7 },
    '& + button': { borderLeft: '1px solid #DADADA' },
    '&[aria-pressed="true"]': { background: '#1E8E3E', color: '#FFFFFF' },
  },
});

export const Notice = styled('div', {
  borderRadius: '6px',
  padding: '10px 12px',
  fontSize: '14px',
  variants: {
    tone: {
      amber: { backgroundColor: '#FFF4D8', color: '#5C4100' },
      red: { backgroundColor: '#FFDFD8', color: '#8A0208' },
    },
  },
});

export const Field = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  '& label': { fontWeight: 600 },
  '& input': {
    padding: '8px 10px',
    border: '1px solid #DADADA',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 400,
  },
});

export const EditLink = styled('button', {
  border: 'none',
  background: 'none',
  padding: 0,
  fontSize: '13px',
  fontWeight: 600,
  color: '#1E8E3E',
  cursor: 'pointer',
  '&:disabled': { color: '#8A8A8A', cursor: 'default' },
});
